import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, GlobeIcon, ClockIcon, BanknoteIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Crisis() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-123">
      <div className="max-w-7xl mx-auto" data-id="element-124">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-125">
          THE iGAMING
          <br data-id="element-126" />
          <span className="text-crimson" data-id="element-127">LOCALIZATION CRISIS</span>
        </h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-0" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-128">
          <motion.div className="border-2 border-ivory/20 border-l-4 border-l-crimson p-6 md:p-10" variants={cardVariants} data-id="element-129">
            <GlobeIcon className="w-10 h-10 md:w-14 md:h-14 text-crimson mb-6" strokeWidth={1.5} data-id="element-130" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-131">
              REGULATORY FRAGMENTATION
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-132">
              50+ jurisdictions with conflicting requirements. Each market
              demands unique compliance documentation, responsible gaming
              messaging, and legal disclaimers — all in the local language and
              legal framework.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-l-4 border-l-cobalt p-6 md:p-10" variants={cardVariants} data-id="element-133">
            <AlertTriangleIcon className="w-10 h-10 md:w-14 md:h-14 text-cobalt mb-6" strokeWidth={1.5} data-id="element-134" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-135">
              CULTURAL INSENSITIVITY
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-136">
              Direct translations destroy player trust. Idioms, humor, cultural
              references, and even color associations vary dramatically. A
              campaign that converts in the UK can offend in the Middle East.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-l-4 border-l-saffron p-6 md:p-10" variants={cardVariants} data-id="element-137">
            <ClockIcon className="w-10 h-10 md:w-14 md:h-14 text-saffron mb-6" strokeWidth={1.5} data-id="element-138" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-139">
              MONTHS-LONG CYCLES
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-140">
              Traditional localization takes 3–6 months per market. By the time
              content is approved, regulations have changed, competitors have
              moved, and market windows have closed.
            </p>
          </motion.div>

          <motion.div className="border-2 border-ivory/20 border-l-4 border-l-emerald p-6 md:p-10" variants={cardVariants} data-id="element-141">
            <BanknoteIcon className="w-10 h-10 md:w-14 md:h-14 text-emerald mb-6" strokeWidth={1.5} data-id="element-142" />
            <h3 className="font-heading font-bold text-ivory uppercase text-xl md:text-2xl mb-4 tracking-tight" data-id="element-143">
              DEVASTATING FINES
            </h3>
            <p className="font-body text-ivory/70 text-base md:text-lg leading-relaxed" data-id="element-144">
              Non-compliance penalties reach €500K+ per violation. Operators
              face license revocation, market exclusion, and reputational damage
              that takes years to recover from.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}